import { useClientPortalAPI } from "@certn/api";

import { useQueryParams } from "../../../hooks/useQueryParams";
import { queryParamsToApiParams } from "../../utils";
import { CasesTable } from "../components/CasesTable";

export function ActiveCasesTab() {
  const { params } = useQueryParams();
  const { data, isLoading, error } = useClientPortalAPI(
    "/api/internal/client-portal/case/active/",
    queryParamsToApiParams(params)
  );

  return (
    <CasesTable
      cases={data}
      isLoading={isLoading}
      error={error}
      statusSubset="active"
    />
  );
}
